export default __webpack_public_path__ + "static/media/sick.a352fa57.png";